(() => {
  'use strict';

  if (window.MoshuluPlpBackToTop?.version === 2) {
    window.MoshuluPlpBackToTop.refresh();
    return;
  }

  let framePending = false;

  function getScrollRoots() {
    const roots = new Set();

    if (document.scrollingElement) {
      roots.add(document.scrollingElement);
    }

    let element = document.querySelector(
      'product-list[data-collection-product-list]'
    ) || document.querySelector('main');

    while (element) {
      const overflow = getComputedStyle(element).overflowY;

      if (
        element.scrollHeight > element.clientHeight &&
        /auto|scroll|overlay/.test(overflow)
      ) {
        roots.add(element);
      }

      element = element.parentElement;
    }

    return Array.from(roots);
  }

  function refresh() {
    const buttons = Array.from(
      document.querySelectorAll('[id="collection-back-to-top"]')
    );

    let button = buttons.find(item =>
      item.hasAttribute('data-plp-back-to-top')
    ) || buttons[0];

    if (!button) {
      button = document.createElement('button');
      button.id = 'collection-back-to-top';
      button.className = 'collection-back-to-top';
    }

    button.type = 'button';
    button.setAttribute('aria-label', 'Back to top');
    button.setAttribute('data-plp-back-to-top', '');

    if (button.textContent !== 'Back to top') {
      button.textContent = 'Back to top';
    }

    if (button.parentElement !== document.body) {
      document.body.append(button);
    }

    buttons.forEach(item => {
      if (item !== button) {
        item.remove();
      }
    });

    const visible =
      window.scrollY > 300 ||
      getScrollRoots().some(root => root.scrollTop > 300);

    button.hidden = !visible;
    button.classList.toggle('is-visible', visible);
  }

  function scheduleRefresh() {
    if (framePending) return;

    framePending = true;

    requestAnimationFrame(() => {
      framePending = false;
      refresh();
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(
      '#collection-back-to-top[data-plp-back-to-top]'
    );

    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const roots = getScrollRoots();
    const main = document.querySelector('main');

    if (main) {
      if (!main.hasAttribute('tabindex')) {
        main.setAttribute('tabindex', '-1');

        main.addEventListener('blur', () => {
          main.removeAttribute('tabindex');
        }, { once: true });
      }

      main.focus({ preventScroll: true });
    }

    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    const behavior = reduceMotion ? 'instant' : 'smooth';

    roots.forEach(root => {
      if (root !== document.scrollingElement) {
        root.scrollTo({
          top: 0,
          behavior
        });
      }
    });

    window.scrollTo({
      top: 0,
      behavior
    });
  }, true);

  document.addEventListener('scroll', scheduleRefresh, {
    capture: true,
    passive: true
  });

  window.addEventListener('scroll', scheduleRefresh, {
    passive: true
  });

  window.addEventListener('resize', scheduleRefresh);
  window.addEventListener('pageshow', scheduleRefresh);

  document.addEventListener(
    'shopify:section:load',
    scheduleRefresh
  );

  document.addEventListener(
    'collection:products-loaded',
    scheduleRefresh
  );

  window.MoshuluPlpBackToTop = {
    version: 2,
    refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      refresh,
      { once: true }
    );
  } else {
    refresh();
  }
})();